import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-127c79a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-info-wrapper" }
const _hoisted_2 = { class: "line-info-content" }
const _hoisted_3 = { class: "line-route-name" }
const _hoisted_4 = {
  key: 0,
  class: "alarm-chip"
}
const _hoisted_5 = {
  key: 1,
  class: "alarm-chip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "favorite-line-row-container",
    onClick: $setup.emitOnClickRow
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode($setup["FavoriteLineSetTypeChip"], {
        lineTypeCode: $props.favoriteLine.lineTypeCode,
        lineTypeName: $props.favoriteLine.lineTypeName,
        earlyDriveInfos: $props.favoriteLine.earlyDriveInfos,
        lineSetList: $props.favoriteLine.lineSets
      }, null, 8 /* PROPS */, ["lineTypeCode", "lineTypeName", "earlyDriveInfos", "lineSetList"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString($setup.useGetLineRouteName(
              $props.favoriteLine.lineTypeCode,
              $props.favoriteLine.routeName,
              $props.favoriteLine.lineNum
            )) + _toDisplayString($setup.departureTimeText) + _toDisplayString($setup.gateNoText), 1 /* TEXT */),
        (!!$props.favoriteLine.getOnBusStop)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " 승차 "))
          : _createCommentVNode("v-if", true),
        (!!$props.favoriteLine.getOffBusStop)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " 하차 "))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    (!$setup.isBoarding)
      ? (_openBlock(), _createBlock($setup["FavoriteStatusButton"], {
          key: 0,
          class: "favorite-btn",
          shouldBeFilled: true,
          onOnClick: $setup.emitOnClickFavoriteStatusButton,
          "aria-label": `${$setup.useGetLineRouteName(
        $props.favoriteLine.lineTypeCode,
        $props.favoriteLine.routeName,
        $props.favoriteLine.lineNum
      )} 노선 즐겨찾기 해제하기`
        }, null, 8 /* PROPS */, ["aria-label"]))
      : (_openBlock(), _createBlock($setup["BoardingStatusButton"], {
          key: 1,
          class: "status-btn",
          onOnClick: $setup.emitOnClickBoardingStatusButton,
          "aria-label": "하차벨 및 신고 팝업 열기"
        }))
  ]))
}